import React from 'react'

function ContactUs() {
    return (
        <div>
        <h1 className="page-title">CONTACT US</h1>
    </div>
    )
}

export default ContactUs
